export default class NavigationModel {
  id: number | null;
  title: string;
  type: string | undefined;
  external_url: string;
  icon: string;
  class_field: string;
  description: string;
  path: string;
  enabled: boolean;
  parent: string;
  organization: string;
  keep_site_context: boolean;

  constructor(
    id: number | null = null,
    title = "",
    type: string | undefined = undefined,
    external_url = "",
    icon = "",
    class_field = "",
    description = "",
    path = "",
    enabled = true,
    parent = "",
    organization = "",
    keep_site_context = false,
  ) {
    this.id = id;
    this.title = title;
    this.type = type;
    this.icon = icon;
    this.external_url = external_url;
    this.class_field = class_field;
    this.description = description;
    this.path = path;
    this.enabled = enabled;
    this.parent = parent;
    this.organization = organization;
    this.keep_site_context = keep_site_context;
  }

  update = (obj: Partial<NavigationModel>) => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        this[key as keyof this] = obj[key as keyof NavigationModel] as never;
      }
    }
  };
}
